import React from 'react';

import styled from '@emotion/styled';
import { parseHTML } from '../../services/parseHTML';

interface HtmlProps {
    content: string;
}

export const Html: React.FC<HtmlProps> = ({ content, ...props }) => (
    <StyledHtml {...props}>{parseHTML(content, 'html')}</StyledHtml>
);

const StyledHtml = styled.div`
    img {
        max-width: 100%;
    }
`;
